import { combineReducers } from 'redux'
import authentReducer from './reducers/authentReducer';
import yellowstoneReducer from './reducers/yellowstoneReducer';
import masterDataReducer from './reducers/masterDataReducer';

export default combineReducers({
    authentReducer,
    yellowstoneReducer,
    masterDataReducer
})